import * as yup from 'yup'
import { createMobileValidator } from './mobileValidation'
import { dateOfBirthValidator } from '@/onboarding/shared/validators/dateOfBirthValidator'

export const countryCodeValidator = yup.string().required('Please select a country code')

export const mobileValidator = createMobileValidator()

export { dateOfBirthValidator }

export const mobileSchema = yup
    .object({
        countryCode: countryCodeValidator,
        mobile: mobileValidator,
        dateOfBirth: dateOfBirthValidator,
    })
    .required()

export type MobileFormValues = yup.InferType<typeof mobileSchema>
